import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { GECKO_UTILS } from '../../../';
import './card-body.scss';

class GeckoCardBody extends Component {
  prepareClasses() {
    return GECKO_UTILS.classNames({
      padded: this.props.padded,
      'padded-vertical': this.props.paddedV,
      'padded-horizontal': this.props.paddedH,
    });
  }

  renderClasses() {
    return `body gecko-card-body ${this.prepareClasses()}`;
  }

  render() {
    return (
      <div className={this.renderClasses()}>
        <div>{this.props.children}</div>
      </div>
    );
  }
}

export default GeckoCardBody;
